// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_INWARD_REQUEST = 'FETCH_YARN_INWARD_REQUEST';
export const FETCH_YARN_INWARD_SUCCESS = 'FETCH_YARN_INWARD_SUCCESS';
export const FETCH_YARN_INWARD_FAILURE = 'FETCH_YARN_INWARD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_YARN_INWARD_REQUEST = 'CREATE_YARN_INWARD_REQUEST';
export const CREATE_YARN_INWARD_SUCCESS = 'CREATE_YARN_INWARD_SUCCESS';
export const CREATE_YARN_INWARD_FAILURE = 'CREATE_YARN_INWARD_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_INWARD = 'CREATE_USER_FORM_YARN_INWARD';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_YARN_INWARD_REQUEST = 'UPDATE_YARN_INWARD_REQUEST';
export const UPDATE_YARN_INWARD_SUCCESS = 'UPDATE_YARN_INWARD_SUCCESS';
export const UPDATE_YARN_INWARD_FAILURE = 'UPDATE_YARN_INWARD_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_YARN_INWARD_REQUEST = 'FETCH_SINGLE_YARN_INWARD_REQUEST';
export const FETCH_SINGLE_YARN_INWARD_SUCCESS = 'FETCH_SINGLE_YARN_INWARD_SUCCESS';
export const FETCH_SINGLE_YARN_INWARD_FAILURE = 'FETCH_SINGLE_YARN_INWARD_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_YARN_INWARD_REQUEST = 'DELETE_YARN_INWARD_REQUEST';
export const DELETE_YARN_INWARD_SUCCESS = 'DELETE_YARN_INWARD_SUCCESS';
export const DELETE_YARN_INWARD_FAILURE = 'DELETE_YARN_INWARD_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE';

export const RESET_FORM_DATA_WITHOUT_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_INWARD_ID';
export const SET_ACTIVE_KEY_YARN_INWARD = 'SET_ACTIVE_KEY_YARN_INWARD';

// USERFORM RESET

export const YARN_INWARD_USERFORM_RESET = 'YARN_INWARD_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_YARN_INWARD_DETAILS = 'NAVIGATE_YARN_INWARD_DETAILS';
// navigate to company component
export const NAVIGATE_YARN_INWARD = 'NAVIGATE_YARN_INWARD';

export const SET_PENDING_GRID_NAME_YARN_INWARD = 'SET_PENDING_GRID_NAME_YARN_INWARD';
export const SET_UNIT_NAME_YARN_INWARD = 'SET_UNIT_NAME_YARN_INWARD';
export const SET_START_DATE_YARN_INWARD = 'SET_START_DATE_YARN_INWARD';
export const SET_END_DATE_YARN_INWARD = 'SET_END_DATE_YARN_INWARD';


export const FILE_UPLOAD_INWARD = 'FILE_UPLOAD_INWARD';
export const FILE_UPLOAD_INWARD_RESET = 'FILE_UPLOAD_INWARD_RESET';

export const FILE_UPLOAD_YARN_PO_IN_INWARD_REQUEST = 'FILE_UPLOAD_YARN_PO_IN_INWARD_REQUEST';
export const FILE_UPLOAD_YARN_PO_IN_INWARD_SUCCESS = 'FILE_UPLOAD_YARN_PO_IN_INWARD_SUCCESS';
export const FILE_UPLOAD_YARN_PO_IN_INWARD_FAILURE = 'FILE_UPLOAD_YARN_PO_IN_INWARD_FAILURE';
